const CategoryDataReference = `
  fragment CategoryDataReference on CategoryDataReference {
    label
    value
  }
`
export default CategoryDataReference
